<template>
    <div class="container">
	<div class="row">
        <div class="container-fluid">
	        <h3 class="title">MES EXPERIENCES</h3>

            <div class="row">
                <Traitement :exper_for="exp.formations"
                            title="PARCOURS SCOLAIRE"
                            class="col-12 col-md left" />
                <Traitement :exper_pro="exp.profession"
                            title="PARCOURS PROFESSIONNEL"
                            class="col-12 col-md right" />
            </div>
        </div>
	</div>
    </div>
</template>

<script>
    import Traitement from "./components/Traitement.vue";
    export default {
        name: 'Experiences',
        props: ['exp'],
        components: {
            Traitement
        }
    };
</script>

<style>
    .row {
        padding-top: 20px;
        text-align: center;
    }
</style>
